//input.js

const addListener = function(el, type, fn) {
    el.addEventListener(type, fn, false)
  }
  
  //去掉空格
  const spaceFilter = function(el) {
    addListener(el, 'input', () => {
      el.value = el.value.replace(/\s+/, '')
    })
  }
  
 // 防抖
let debounce = (fn, delayTime) => {
    let delay = delayTime || 300;
    var timer;
    return function() {
    var th = this;
    var args = arguments;
    if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(function() {
          timer = null;
          fn.apply(th, args);
        }, delay);
      };
    }
    // 限制只能输入整数和小数（适用于价格类、最多两位小数）
    const priceFilter = function(el) {
        let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
        // (el.value.match(/^\d*(\.?\d{0,2})/g)[0])
    addListener(el, 'keyup', debounce(() => {//添加防抖 方便添加小数点
        console.log('origin',el.value)
        // console.log('match',el.value.match(/^\d*(\.?\d{0,2})/g))
        // console.log('match',el.value.match(/^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/g))
        // el.value = el.value.match(/^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/g)[0]
        // el.value = (el.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
        let idnex = el.value.indexOf(".")
        if(idnex < 0){
            el.value = el.value.slice(0,9)

        }else{
            el.value = el.value.slice(0,9)+el.value.slice(idnex)
        }
        el.value = el.value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
        // if(/^([0-9]|[1-9][0-9]{0,8})/g.test(el.value)){
           
        // }
        el.value = el.value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
        el.value = el.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        el.value = el.value.replace(/^(\-)*(\d{9})\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
        
        if (el.value.indexOf(".") < 0 && el.value != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        el.value = parseFloat(el.value);
        }

    
        
    if (isNaN(el.value)) {
          el.value = ''
        }
    //格式化去掉却没有输入小数位的小数点
        el.value = +el.value
  
    //触发input事件
        el.dispatchEvent(new Event('input'))
        
      }))
    }

    const numberFilter = function(el){
        addListener(el, 'keyup', () => {
            el.value = el.value.replace(/[^\d]/g, "");
            el.dispatchEvent(new Event('input'))
          })
    }

    // 限制只能输入字母数字（适用于运单号）
    const integerLetterFilter = function(el) {
      addListener(el, 'keyup', () => {
        el.value = el.value.replace(/[\W]/g,'')
        el.dispatchEvent(new Event('input'))
      })
    }



  
  export default {
    bind(el, binding) {
      if (el.tagName.toLowerCase() !== 'input') {
        el = el.getElementsByTagName('input')[0]
      }
      spaceFilter(el)
      switch (binding.arg) {
        case 'price':
          priceFilter(el)
          break
        case 'integerLetter':
          integerLetterFilter(el)
          break
        case 'number':
            numberFilter(el)
            break
        default:
          console.warn('未知指令类型',binding.arg)
          break
      }
    }
  }
